(() => {
  'use strict';

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const headingSelector = 'h1,h2,h3,h4,h5,h6';

  const isFitmentHeading = (value) => {
    const text = normalize(value);
    return text === 'compatible vehicles' ||
      text === 'compatibile vehicles' ||
      text === 'this part fits the following vehicles' ||
      text === 'this part fits the following vehicle' ||
      text === 'fits the following vehicles' ||
      text === 'fits the following vehicle' ||
      text === 'fits these machines' ||
      text === 'vehicle fitment' ||
      text === 'fitment';
  };

  const removeFitmentLabels = (source) => {
    const candidates = Array.from(source.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong,b,span,div'));
    candidates.forEach((node) => {
      if (node.querySelector?.('table')) return;
      if (isFitmentHeading(node.textContent)) node.remove();
    });
  };

  const isShippingHeading = (value) => {
    const text = normalize(value);
    return text === 'shipping' ||
      text.includes('shipping & handling') ||
      text.includes('shipping and handling');
  };

  const topLevelChild = (node, root) => {
    let current = node;
    while (current && current.parentElement && current.parentElement !== root) {
      current = current.parentElement;
    }
    return current;
  };

  const findPreviousHeading = (table, source) => {
    let node = topLevelChild(table, source)?.previousElementSibling;
    let checks = 0;
    while (node && checks < 8) {
      if (node.matches?.(headingSelector) && isFitmentHeading(node.textContent)) return node;
      const nested = node.querySelector?.(headingSelector);
      if (nested && isFitmentHeading(nested.textContent)) return nested;
      node = node.previousElementSibling;
      checks += 1;
    }
    return null;
  };

  const findFitment = (source) => {
    const tables = Array.from(source.querySelectorAll('table'));
    for (const table of tables) {
      const heading = findPreviousHeading(table, source);
      if (heading) return { table, heading };
    }
    return tables.length === 1 ? { table: tables[0], heading: null } : null;
  };

  const renameConditionHeading = (source) => {
    const headings = Array.from(source.querySelectorAll(headingSelector));
    const heading = headings.find((item) => {
      const text = normalize(item.textContent);
      return text === 'description' ||
        text === 'part description' ||
        text === 'parts condition' ||
        text === 'this parts condition';
    });
    if (heading) heading.textContent = 'Part Condition';
  };

  const findShippingStart = (source) => {
    const headings = Array.from(source.querySelectorAll(headingSelector));
    const heading = headings.find((item) => isShippingHeading(item.textContent));
    return heading ? topLevelChild(heading, source) : null;
  };

  const makeLongDetailsCollapsible = (source, firstDetailNode) => {
    if (!firstDetailNode || !source.contains(firstDetailNode)) return;

    const details = document.createElement('details');
    details.className = 'duffs-listing-details';

    const summary = document.createElement('summary');
    summary.textContent = 'Shipping, Returns & Listing Details';

    const content = document.createElement('div');
    content.className = 'duffs-listing-details__content';

    let node = firstDetailNode;
    while (node) {
      const next = node.nextElementSibling;
      content.appendChild(node);
      node = next;
    }

    details.appendChild(summary);
    details.appendChild(content);
    source.appendChild(details);
  };

  const cleanEmptyElements = (source) => {
    source.querySelectorAll('p,div,figure').forEach((node) => {
      if (!node.children.length && !normalize(node.textContent)) node.remove();
    });
  };

  const prepareTable = (table) => {
    table.removeAttribute('style');
    table.classList.add('duffs-fitment__table');
    table.querySelectorAll('[style]').forEach((node) => node.removeAttribute('style'));
  };

  const initProductLayout = () => {
    const source = document.querySelector('.product-summary .product-description');
    const fitmentRoot = document.querySelector('[data-duffs-fitment]');
    const fitmentTarget = fitmentRoot?.querySelector('[data-duffs-fitment-content]');

    if (!source) return;

    renameConditionHeading(source);

    const fitment = findFitment(source);
    let detailsStart = null;

    if (fitment && fitmentRoot && fitmentTarget) {
      const { table, heading } = fitment;
      const tableContainer = topLevelChild(table, source);
      detailsStart = tableContainer?.nextElementSibling || null;

      prepareTable(table);

      const rows = Array.from(table.querySelectorAll('tr'));
      const bodyRows = table.querySelector('thead')
        ? Array.from(table.querySelectorAll('tbody tr'))
        : rows.slice(1);
      const extraRows = bodyRows.slice(4);
      extraRows.forEach((row) => row.classList.add('duffs-fitment__row--extra'));

      fitmentTarget.appendChild(table);
      if (heading) heading.remove();
      removeFitmentLabels(source);
      fitmentRoot.hidden = false;

      const toggle = fitmentRoot.querySelector('[data-duffs-fitment-toggle]');
      if (toggle && extraRows.length) {
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          const expanded = fitmentRoot.classList.toggle('is-expanded');
          toggle.textContent = expanded ? 'Show less fitment' : 'Show all fitment';
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      }
    }

    if (!detailsStart) detailsStart = findShippingStart(source);
    makeLongDetailsCollapsible(source, detailsStart);
    cleanEmptyElements(source);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductLayout, { once: true });
  } else {
    initProductLayout();
  }
})();
